<template>
    <v-navigation-drawer class="text-light-blue" permanent>
      <v-divider></v-divider>
      <br/>
      <v-list-item>
        <v-list-item>
          <v-list-item-title>Exclusion Areas</v-list-item-title>
        </v-list-item>
      </v-list-item>
    
      <div class="exclusion-list">
        <div v-for="{ properties: areaProps } in exclusionAreas?.features" :key="areaProps.id">
            <div class="exclusion-list-item" @click="sendEvent(areaProps.id)">
                <div class="list-item-id">{{areaProps.id}}</div>
                <div class="list-item-body">
                    <div class="title">{{areaProps.name}}</div>
                </div>
            </div>
          <v-divider></v-divider>
        </div>
      </div>

      <div class="bottom">
          <v-list-item>
              <v-btn color="info" prepend-icon="mdi-plus-thick" block  @click="$emit('addExclusionArea')">
                New Exclusion Area
              </v-btn>
          </v-list-item>
      </div>
    </v-navigation-drawer>
  </template>
  
  <script>
  import "maplibre-gl/dist/maplibre-gl.css";

  
  export default {
    name: "ExclusionAreaSidebar",
    props:["exclusionAreas"],
    data() {
      return {

      }
    },
    methods: {
        sendEvent(id) {
            this.$emit("sidebarEvent", id);
        }
    }
  }
  </script>
  
  <style scoped>
  
  .bottom {
    position: absolute;
    bottom: 0;
  }
  .v-select__selection,
  .v-select__selection--comma,
  .v-select.v-text-field input {
    color: #2196F3 !important;
  }


  .exclusion-list {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    width: 100%;
    height: 75vh;
    overflow: auto;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .exclusion-list-item{
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 17px 0;
  }

  .exclusion-list-item:hover{
    background-color: #ADD8E6;
    cursor: pointer;
  }

  .list-item-id{
    width: 20%;
    font-size: 20px;
    color: #2196F3;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .list-item-body{
    width: 80%;
    color: #2196F3;
    text-align: center;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .list-item-body > .title{
    font-size: 15px;
    text-align: left;
  }

  .list-item-body > .info{
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: space-between;
  }

  .list-item-body >.info> .icons{
    display: flex;
    padding: 0px 10px 0px 0;
  }

  .list-item-body >.info> .icons > .v-icon{
    padding: 0 13px;
  }
  .list-item-body >.info> .icons:last-child{
    padding-right: 0;
  }
  </style>